import { render, staticRenderFns } from "./graduationCertificate.vue?vue&type=template&id=83e6601c&scoped=true&"
import script from "./graduationCertificate.vue?vue&type=script&lang=js&"
export * from "./graduationCertificate.vue?vue&type=script&lang=js&"
import style0 from "./graduationCertificate.vue?vue&type=style&index=0&id=83e6601c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e6601c",
  null
  
)

export default component.exports